import React from "react";
import ImageEditorComponent from "../components/ImageEditor";

function App() {
  return (
    <div>
      <ImageEditorComponent />
    </div>
  );
}

export default App;
